const pendingActions = new Map<string, Promise<unknown>>();

const serializePayload = (data: unknown): string => {
  if (data === undefined || data === null) {
    return '';
  }

  if (data instanceof FormData) {
    return Array.from(data.entries())
      .map(([key, value]) => {
        if (value instanceof File) {
          return `${key}:${value.name}:${value.size}`;
        }
        return `${key}:${String(value)}`;
      })
      .join('|');
  }

  try {
    return JSON.stringify(data);
  } catch {
    return String(data);
  }
};

export const buildActionKey = (method: string, url: string, data?: unknown): string =>
  `${method.toUpperCase()}:${url}:${serializePayload(data)}`;

export const runLockedAction = async <T>(key: string, action: () => Promise<T>): Promise<T> => {
  const existing = pendingActions.get(key);
  if (existing) {
    return existing as Promise<T>;
  }

  const promise = action().finally(() => {
    pendingActions.delete(key);
  });

  pendingActions.set(key, promise);
  return promise;
};
